import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Liest `?highlight=<id>` aus der URL und markiert die Zeile mit dem
 * passenden `data-highlight-id` Attribut (scrollt + Ring-Effekt für 3s).
 * Entfernt den Query-Param danach aus der URL.
 *
 * Nutze es in jeder Listen-Page nach dem Laden der Daten:
 *   useHighlightParam(invoices, (i) => i._id || i.id);
 */
export default function useHighlightParam(items, getId) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!items || items.length === 0) return;
    const params = new URLSearchParams(location.search);
    const target = params.get("highlight");
    if (!target) return;

    const match = items.find((x) => getId(x) === target);
    if (!match) return;

    // scroll + highlight
    const tries = [0, 100, 250, 500]; // DOM may still be mounting
    let done = false;
    tries.forEach((delay) => {
      setTimeout(() => {
        if (done) return;
        const el = document.querySelector(
          `[data-highlight-id="${CSS.escape(target)}"]`
        );
        if (el) {
          done = true;
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.classList.add("cmdk-highlight-ring");
          setTimeout(() => {
            el.classList.remove("cmdk-highlight-ring");
          }, 2500);
        }
      }, delay);
    });

    // Clean query param from URL (no history entry)
    const nextParams = new URLSearchParams(location.search);
    nextParams.delete("highlight");
    const suffix = nextParams.toString();
    navigate(
      { pathname: location.pathname, search: suffix ? `?${suffix}` : "" },
      { replace: true }
    );
  }, [items, location.search]);
}
